module.exports = __webpack_public_path__ + "static/img/moaInstallForWin_pic02.579b258.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moaInstallForWin/moaInstallForWin_pic02.png
// module id = 536
// module chunks = 1